import { render, staticRenderFns } from "./EmployeesNavigation.vue?vue&type=template&id=77485a9a&scoped=true"
import script from "./EmployeesNavigation.vue?vue&type=script&lang=ts"
export * from "./EmployeesNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77485a9a",
  null
  
)

export default component.exports